import { store } from '@wajeez-web/stores/base';
import { handleDispatchResult } from '@wajeez-web/core/utils';
import { Server } from '@wajeez-web/core/api-base';

import { getAllInterestsPublicAsync, setUserInterestsAsync } from './slices';

export const getAllInterestsPublic = async (
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getAllInterestsPublicAsync());

  return handleDispatchResult(res, onSuccess);
};

export const setUserInterests = async (
  data: Server.SetReaderInterestsInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(setUserInterestsAsync(data));

  return handleDispatchResult(res, onSuccess);
};
